import type { LocalePack } from './types.js';

/** Italian (Italiano) */
export const it: LocalePack = {
  headerTitle: 'Editor foto',
  headerSubtitle: 'Modifica la tua immagine con facilità',
  applyButton: 'Applica',
  cancelButton: 'Chiudi',
  undo: 'Annulla',
  redo: 'Ripeti',
  fullscreen: 'Schermo intero',
  fit: 'Adatta',
  zoomTooltip: 'Zoom · +/− · 0 adatta · 1 100 %',

  emptyStateTitle: "Rilascia un'immagine o clicca per caricare",
  emptyStateSubtitle: 'Supportati: PNG, JPEG, HEIC',

  calloutLabelText: 'Etichetta',

  tool: {
    select: 'Seleziona',
    crop: 'Ritaglia',
    draw: 'Disegna',
    eraser: 'Gomma',
    text: 'Testo',
    shapes: 'Forme',
    callout: 'Nota',
    filters: 'Filtri',
    adjust: 'Regola',
    move: 'Sposta',
    pen: 'Penna',
    zoom: 'Zoom',
    zoomIn: 'Zoom avanti',
    zoomOut: 'Zoom indietro',
    rotateLeft: 'Ruota a sinistra',
    rotateRight: 'Ruota a destra',
    flipH: 'Rifletti O',
    flipV: 'Rifletti V',
    reset: 'Ripristina',
  },

  shape: {
    circle: 'Cerchio',
    ellipse: 'Ellisse',
    square: 'Quadrato',
    rectangle: 'Rettangolo',
    arrow: 'Freccia',
    polyline: 'Linea',
  },

  filter: {
    none: 'Originale',
    grayscale: 'B/N',
    sepia: 'Seppia',
    vintage: 'Vintage',
    cool: 'Freddo',
    warm: 'Caldo',
    invert: 'Inverti',
  },

  props: {
    title: {
      draw: 'Disegna',
      eraser: 'Gomma',
      text: 'Testo',
      crop: 'Ritaglia',
      shapes: 'Forme',
      callout: 'Nota',
      filters: 'Filtri',
      adjust: 'Regola',
      move: 'Sposta',
    },
    aspectRatio: 'Proporzioni',
    applyCrop: 'Applica ritaglio',
    cancel: 'Annulla',
    shape: 'Forma',
    preset: 'Preset',
    resetEffects: 'Reimposta effetti',
    resetAdjustments: 'Reimposta regolazioni',
    deleteSelected: 'Elimina selezione',
    colors: 'Colori',
    recent: 'Recenti',
    customColor: 'Colore personalizzato',
    brushSize: 'Dimensione pennello',
    strokeWidth: 'Spessore tratto',
    opacity: 'Opacità',
    eraserSize: 'Dimensione gomma',
    fontSize: 'Dimensione carattere',
    brightness: 'Luminosità',
    contrast: 'Contrasto',
    saturation: 'Saturazione',
    blur: 'Sfocatura',
    quickActions: 'Azioni rapide',
    hintMove:
      "Trascina per spostare · pizzica o scorri per zoomare · scegli uno strumento per iniziare.",
    hintEraser: "Tocca o trascina su un'annotazione per rimuoverla.",
  },
};
